import React from 'react';
import * as XLSX from 'xlsx';

const ExportToExcel = ({ data, columns, fileName = 'data.xlsx' }) => {
    const exportToExcel = () => {
        // تنظیم داده‌ها برای اکسل به صورت داینامیک
        const excelData = data.map(row => {
            let rowData = {};
            columns.forEach(col => {
                rowData[col.name] = col.format ? col.format(row) : col.selector(row);
            });
            return rowData;
        });

        // ایجاد worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // ایجاد workbook و افزودن worksheet به آن
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        // ایجاد فایل اکسل و دانلود آن
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <button onClick={exportToExcel} className="btn btn-white btn-outline-light d-flex align-items-center">
            <em className="icon ni ni-file-xls"></em>
            <span>خروجی Excel</span>
        </button>
    );
};

export default ExportToExcel;
